import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MediaGet } from "../../apis/api/GalleryApis";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";
import BusinessCardModel from "../../Models/BuisnessCardsModel/BuisnessCardsModel";

const LeftSidebarColunm = ({ profileData }) => {
  const location = useLocation();
  const { company_id, userId } = location.state || {};
  const [showBuisnessModal, setShowBuisnessModal] = useState(false);
  const [Photodata, setPhotodata] = useState([]);
  const [Videodata, setVideodata] = useState([]);
  const [businessCardData, setShowBuisnesscard] = useState();
  const { album } = useSelector((state) => state.GallerySlice);

  const company_data = profileData?.data?.company_data;
  const member_data = profileData?.data?.member_data;

  const service_data = profileData?.data?.services;
  const Certificate_data = profileData?.data?.Certificates;

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const NavigateAlbum = () => {
    navigate("/albumCard", { state: { from: location.pathname } });
  };
  const Navigatephoto = () => {
    navigate("/photos-gallery",{ state: { from: location.pathname } });
  };
  const Navigatevideo = () => {
    navigate("/videos-gallery",{ state: { from: location.pathname } });
  };

  const navigateCertificate = (company_id) => {
    navigate("/certificates", { state: { company_id , from: location.pathname} });
  };

  const navigateMember = () => {
    navigate("/member", {
      state: {
        company_id: company_id,
        userId: userId,
        from: location.pathname
      },
    });
  };

  useEffect(() => {
    (async () => {
      await dispatch(MediaGet({ company_id }));
    })();
  }, [company_id, dispatch]);

  const { media } = useSelector((state) => state.GallerySlice);

  useEffect(() => {
    if (media?.result && media?.result?.length > 0) {
      const photoItems = media?.result.filter(
        (item) => item.extension_type == "image"
      );
      const videoItems = media?.result.filter(
        (item) => item.extension_type == "video"
      );

      setPhotodata(photoItems);
      setVideodata(videoItems);
    } else {
      setPhotodata([]);
      setVideodata([]);
    }
  }, [media]);

  function formatDate(timestamp) {
    if (!timestamp) return " ";
    const date = new Date(Number(timestamp) * 1000);

    if (isNaN(date.getTime())) return "Invalid Date";

    const day = date.getDate();
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }
  function filterMemeberDataforCard(id) {
    const filterddata = member_data.filter((member) => {
      return member.id == id;
    });
    setShowBuisnesscard(filterddata);
    setShowBuisnessModal(true);
  }
  return (
    <>
      <BusinessCardModel
        show={showBuisnessModal}
        handleClose={() => setShowBuisnessModal(false)}
        data={businessCardData}
      />
      <div className="col-md-6 col-12 fixed-column">
        <div className="form-row col-12  col-md-12 col-lg-12 col-xl-12 col-xxl-12 z-14 child">
          <div className="intro w-100 bg-white">
            <section class="container container1 ">
              <div class="row align-items-center">
                <div class="container my-2 ">
                  <div class="col-md-12 d-flex align-items-center justify-content-between mb-4">
                    <div class="d-flex align-items-center">
                      <i class="fas fa-globe me-1 "></i>
                      <h4 class="fw-bold text-theme mb-0">Intro</h4>
                    </div>
                  </div>

                  <div class="row justify-content-center">
                    <div>
                      <p className="lead text-muted fs-6 mb-4">
                        {company_data?.bio ? (
                          /<[a-z][\s\S]*>/i.test(company_data.bio) ? (
                            <span>
                              {company_data.bio.replace(/<[^>]*>?/gm, "").replace('&nbsp;', '')}
                            </span>
                          ) : (
                            <span>{company_data.bio}</span>
                          )
                        ) : (
                          <span>company bio...</span>
                        )}
                      </p>

                      <hr />
                      <div className="d-flex justify-content-start">
                        <ul className="list-unstyled text-start f">
                          <li className="mb-2 fs-6">
                            Membership Start Date:{" "}
                            {formatDate(company_data?.membership_start)}
                          </li>
                          <li className="mb-2 fs-6">
                            Membership End Date:{" "}
                            {formatDate(company_data?.membership_expire)}
                          </li>
                          <li className="mb-2 fs-6">
                            Foundation Date:{" "}
                            {company_data?.foundation_date}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <div className="container mb-3 container1 w-100 bg-white">
            <div className="mt-3">
              <h4 className="text-theme mt-3 mb-4 ms-1">Media</h4>
            </div>

            <div></div>

            <div className="container mt-4">
              <div className="row g-4">
                {(album &&
                  album.result &&
                  album.result[0] &&
                  album.result[0].data &&
                  album.result[0].data.length > 0) ||
                (Photodata &&
                  Photodata[0] &&
                  Photodata[0].file_url &&
                  Photodata[0].file_url.length > 0) ||
                (Videodata &&
                  Videodata[0] &&
                  Videodata[0].file_url &&
                  Videodata[0].file_url.length > 0) ? (
                  <>
                    {album &&
                      album.result &&
                      album.result[0] &&
                      album.result[0].data &&
                      album.result[0].data.length > 0 && (
                        <div className="col-md-4">
                          <div
                            className="album-card shadow border-0 rounded-3"
                            onClick={NavigateAlbum}
                          >
                            <div className="card-body text-center d-flex flex-column align-items-center mt-2">
                              <h5 className="card-title fw-bold mb-4">
                                Albums
                              </h5>
                              {album.result.length > 0 && (
                                <div className="w-100">
                                  <div className="row row-cols-2 g-2">
                                    {album.result[0].data
                                      .slice(0, 4)
                                      .map((item, index) => (
                                        <div className="col" key={index}>
                                          {item.extension_type === "image" && (
                                            <img
                                              src={item.file_url}
                                              className="img-fluid rounded-2"
                                              alt={`Album ${index + 1}`}
                                            />
                                          )}
                                          {item.extension_type === "video" && (
                                            <video
                                              src={item.file_url}
                                              className="img-fluid rounded-2"
                                              controls
                                            />
                                          )}
                                          {item.extension_type === "audio" && (
                                            <div
                                              className="bg-light rounded-2 p-2 d-flex justify-content-center align-items-center"
                                              style={{ height: "100px" }}
                                            >
                                              <audio controls className="w-100">
                                                <source
                                                  src={item.file_url}
                                                  type="audio/mpeg"
                                                />
                                                Your browser does not support
                                                the audio element.
                                              </audio>
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                    {Photodata &&
                      Photodata[0] &&
                      Photodata[0].file_url &&
                      Photodata[0].file_url.length > 0 && (
                        <div className="col-md-4">
                          <div
                            className="card album-card shadow border-0 rounded-3"
                            onClick={Navigatephoto}
                          >
                            <div className="card-body text-center d-flex flex-column align-items-center">
                              <h5 className="card-title fw-bold">Photos</h5>
                              <img
                                src={Photodata[0].file_url}
                                className="rounded-3 mt-3 p-2 album-img"
                                alt="Album"
                              />
                            </div>
                          </div>
                        </div>
                      )}

                    {Videodata &&
                      Videodata[0] &&
                      Videodata[0].file_url &&
                      Videodata[0].file_url.length > 0 && (
                        <div className="col-md-4">
                          <div
                            className="card album-card shadow border-0 rounded-3"
                            onClick={Navigatevideo}
                          >
                            <div className="card-body text-center d-flex flex-column align-items-center">
                              <h5 className="card-title fw-bold">Videos</h5>
                              <video
                                src={Videodata[0].file_url}
                                className="rounded-3 mt-3 p-2 album-img"
                                controls
                                width="100%"
                              >
                                Your browser does not support the video tag.
                              </video>
                            </div>
                          </div>
                        </div>
                      )}
                  </>
                ) : (
                  <p className="text-bold text-center">No media available.</p>
                )}
              </div>
            </div>
          </div>

          <div className="container mb-3 w-100 bg-white p-4 shadow rounded">
            <div className="col-md-12 d-flex align-items-center justify-content-between mb-4">
              <div className="d-flex align-items-center">
                <i className="fas fa-globe me-1"></i>
                <h4 className="fw-bold text-theme mb-0">Contact</h4>
              </div>
            </div>

            {member_data?.length > 0 ? (
              <div className="row">
                {member_data.map((member, index) => (
                  <div
                    key={index}
                    className="col-12 col-sm-12 col-md-6 col-lg-6"
                  >
                    <div className="our-team rounded-1">
                      <div className="picture">
                        <img
                          className="img-fluid w-100 h-100"
                          src={member?.member_logo ||
                            `${process.env.PUBLIC_URL}/gray-avatar-icon-vector-illustration_276184-163.avif`}
                          alt="team member"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src =
                              "/gray-avatar-icon-vector-illustration_276184-163.avif";
                          }}
                        />
                      </div>

                      <div className="team-content">
                        {(member.salutation ||
                          member.first_name ||
                          member.middle_name ||
                          member.last_name) && (
                          <span className="name">
                            {`${member.salutation || ""} ${
                              member.first_name || ""
                            } ${member.middle_name || ""} ${
                              member.last_name || ""
                            }`.trim()}
                          </span>
                        )}

                        {member.job_title && (
                          <h6 className="title">{member.job_title}</h6>
                        )}
                      </div>

                      {member.department && (
                        <span>Department: {member.department}</span>
                      )}

                      {member.contact && (
                        <p className="mt-3">
                          +{member.country_code}
                          {member.contact}
                        </p>
                      )}

                      {member.email && <p className="mt-3">{member.email}</p>}
                      <button
                        class="btn btn-outline-secondary btn-sm"
                        onClick={() => filterMemeberDataforCard(member.id)}
                      >
                        <i class="bx bx-show"></i> View Business Card
                      </button>
                      <ul className="social">
                        {/* WhatsApp */}
                        {member?.contact && (
                          <li>
                            <a
                              href={`https://wa.me/${String(
                                member.country_code
                              ).replace(/\D/g, "")}${String(
                                member.contact
                              ).replace(/\D/g, "")}`}
                              className="bx bxl-whatsapp"
                              aria-hidden="true"
                              target="_blank"
                              rel="noopener noreferrer"
                            ></a>
                          </li>
                        )}

                        {/* Phone */}
                        {/* {member?.contact && (
                          <li>
                            <a
                              href={`tel:+${member?.country_code}${member?.contact}`}
                              className="bx bx-phone"
                              aria-hidden="true"
                            ></a>
                          </li>
                        )} */}

                        {/* Email */}
                        {member?.email && (
                          <li>
                            <a
                              href={`mailto:${member?.email}`}
                              className="bx bx-envelope"
                              aria-hidden="true"
                            ></a>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                ))}

                {member_data.length > 1 && (
                  <div className="text-center mt-3">
                    <button
                      className="btn btn-outline-secondary bg-theme-color btn-sm"
                      onClick={() => navigateMember()}
                    >
                      View All Members
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <p>No Contact available.</p>
            )}
          </div>

          <div className="container mb-3 w-100 bg-white p-4 shadow rounded">
            <div className="col-md-12 d-flex align-items-center justify-content-between mb-4">
              <div className="d-flex align-items-center">
                <i className="fas fa-file-alt me-1"></i>
                <h4 className="fw-bold text-theme mb-0">Certificates</h4>
              </div>
            </div>

            {Certificate_data && Certificate_data.length > 0 ? (
              <div className="row">
                {Certificate_data.slice(0, 3).map((cert) => (
                  <div
                    key={cert.id}
                    className="col-12 col-sm-6 col-md-6 col-lg-4 mb-4 border-rounded"
                  >
                    <div
                      className="card h-100 shadow-sm border-0"
                      style={{
                        transition: "transform 0.2s, box-shadow 0.2s",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "translateY(-5px)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "translateY(0px)")
                      }
                    >
                      <div
                        className="card-img-top text-center bg-light p-3"
                        style={{ height: "180px" }}
                      >
                        {cert.file_extension === "pdf" ? (
                          <i className="bx bxs-file-pdf fs-1 text-danger"></i>
                        ) : cert.file_extension === "doc" ||
                          cert.file_extension === "docx" ? (
                          <i className="bx bxs-file-doc fs-1 text-primary"></i>
                        ) : (
                          <img
                            src={cert.file_url}
                            alt={cert.file_name}
                            className="img-fluid rounded"
                            style={{
                              maxHeight: "140px",
                              objectFit: "cover",
                            }}
                          />
                        )}
                      </div>
                      <div className="card-body">
                        <h6
                          className="card-title text-truncate"
                          title={cert.file_name}
                        >
                          {cert.file_name}
                        </h6>
                        <p className="text-muted small mb-2">
                          Uploaded:{" "}
                          {new Date(
                            cert.created_at * 1000
                          ).toLocaleDateString()}
                        </p>
                        <div className="d-flex justify-content-between">
                          <a
                            href={cert.file_url}
                            className="btn btn-sm btn-outline-warning me-2"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="bx bx-show"></i>
                          </a>
                          <a
                            href={cert.file_url}
                            className="btn btn-sm btn-outline-primary"
                            download
                          >
                            <i className="bx bx-download"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p>No documents available.</p>
            )}

            {Certificate_data?.length > 3 && (
              <div className="text-center mt-3">
                <button
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => navigateCertificate(company_id)}
                >
                  View More <i className="bx bx-right-arrow-alt"></i>
                </button>
              </div>
            )}
          </div>

          <div className="container mb-3 w-100 bg-white p-4 shadow rounded">
            <div class="col-md-12 d-flex align-items-center justify-content-between mb-4">
              <div class="d-flex align-items-center">
                <i class="fas fa-globe me-1 "></i>
                <h4 class="fw-bold text-theme mb-0">Services</h4>
              </div>
            </div>
            {service_data && service_data.length > 0 ? (
              <div className="row">
                {service_data.map((service, index) => (
                  <div key={index} className="col-md-6 col-lg-6 col-sm-6 mb-3">
                    <div className="d-flex align-items-center p-3 border rounded shadow-sm bg-light">
                      {service.icon_url && (
                        <img
                          src={service.icon_url}
                          alt="Service Icon"
                          style={{ height: "33px" }}
                          className="me-2"
                        />
                      )}
                      <span className="fw-bold">{service.service_name}</span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p> No services Available. </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default LeftSidebarColunm;
